export default __webpack_public_path__ + "static/InterDisplay-ExtraBold-8da0ba6e2cd71d3aa285afd318b6cd98.woff";